import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'react-native-paper';
import { colors, spacing, typography } from '../../../constants/theme';
import { ReviewTemplate, TemplateModalMode } from '../AdminDashboard.types';
import AdminTemplateCard from './AdminTemplateCard';

interface AdminTemplatesSectionProps {
  templates: ReviewTemplate[];
  onCreateTemplate: () => void;
  onDeleteTemplate: (templateId: number) => void;
  onManageVendors: (template: ReviewTemplate) => void;
  onOpenTemplateModal: (mode: TemplateModalMode, template: ReviewTemplate) => void;
}

export const AdminTemplatesSection: React.FC<AdminTemplatesSectionProps> = ({
  templates,
  onCreateTemplate,
  onDeleteTemplate,
  onManageVendors,
  onOpenTemplateModal,
}) => {
  const sortedTemplates = [...templates].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <View style={styles.sectionHeader}>
        <Text style={styles.sectionTitle}>Templates ({templates.length})</Text>
        <Button
          mode="contained"
          onPress={onCreateTemplate}
          style={styles.createButton}
        >
          + New Template
        </Button>
      </View>

      {sortedTemplates.length > 0 ? (
        sortedTemplates.map(template => (
          <AdminTemplateCard
            key={template.id}
            template={template}
            onManageVendors={onManageVendors}
            onOpenTemplateModal={onOpenTemplateModal}
            onDeleteTemplate={onDeleteTemplate}
          />
        ))
      ) : (
        <Text style={styles.stat}>No templates found</Text>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  sectionTitle: {
    ...typography.h2,
    marginBottom: spacing.md,
  },
  createButton: {},
  stat: {
    ...typography.caption,
    color: colors.textSecondary,
  },
});

export default AdminTemplatesSection;
